import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCoderwallComponent } from './simple-icons-coderwall.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCoderwallComponent ],
    exports:      [ SimpleIconsCoderwallComponent ],
    bootstrap:    []
})
export class SimpleIconsCoderwallModule {}
